import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { Badge } from '@seeqdev/qomponents';

export type SearchGroupHeaderProps = {
  testId?: string;
  showPreviewBadge: boolean;
  showNewBadge: boolean;
  disableSearchGroup: boolean;
  label: string;
  setModeClick?: () => void;
};

type SearchGroupHeaderContentProps = {
  label: string;
  showPreviewBadge: boolean;
  showNewBadge: boolean;
};

const SearchGroupHeaderContent = ({ label, showPreviewBadge, showNewBadge }: SearchGroupHeaderContentProps) => {
  const { t } = useTranslation();
  return (
    <>
      {label}
      {showPreviewBadge ? (
        <Badge testId="preview-badge" variant="preview" xstyle={styles.badge}>
          {t('PREVIEW')}
        </Badge>
      ) : null}
      {showNewBadge ? (
        <Badge testId="new-badge" xstyle={styles.badge}>
          {t('HOME_SCREEN.NEW')}
        </Badge>
      ) : null}
    </>
  );
};

export const SearchGroupHeader = ({
  testId,
  showPreviewBadge,
  showNewBadge,
  disableSearchGroup,
  label,
  setModeClick,
}: SearchGroupHeaderProps) => {
  return (
    <span data-testid={testId} {...stylex.props(disableSearchGroup && styles.disabled)}>
      {setModeClick ? (
        <button type="button" disabled={disableSearchGroup} onClick={setModeClick} {...stylex.props(styles.action)}>
          <SearchGroupHeaderContent label={label} showPreviewBadge={showPreviewBadge} showNewBadge={showNewBadge} />
        </button>
      ) : (
        <span>
          <SearchGroupHeaderContent label={label} showPreviewBadge={showPreviewBadge} showNewBadge={showNewBadge} />
        </span>
      )}
    </span>
  );
};

export const styles = stylex.create({
  badge: { marginLeft: 7 },
  disabled: { opacity: 0.44 },
  action: {
    cursor: { 'default': 'pointer', ':disabled': 'default' },
    appearance: 'none',
    borderWidth: 0,
    backgroundColor: 'transparent',
    padding: 0,
    textAlign: 'left',
  },
});
